<template>
    <div id="post">
        <Header></Header>
        <loader @onLoadingComplete="onLoadingComplete"></loader>
        <post-page v-show="!loading"></post-page>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../components/common/Header'
    import Footer from '../components/common/Footer'
    import PostPage from '../components/pages/PostPage'
    import Loader from '../components/common/Loader'

    export default {
        name: 'Post',
        data() {
            return {
                loading: true,
            }
        },
        components: {
            Header,
            PostPage,
            Footer,
            Loader
        },
        methods: {
            onLoadingComplete(stat) {
                this.loading = stat;
            }
        },
        mounted() {
            let is_draft = '';

            if(this.$route.query) {
                if(this.$route.query.d == 1) {
                    is_draft = '/draft';
                }
            }

            this.$store.dispatch('getPost', this.$route.params.post_shortname+is_draft);
            this.$store.dispatch('getRecentPosts', this.$route.params.menu_path);
            this.$store.dispatch('getMostPopularPosts', this.$route.params.menu_path);
            this.$store.dispatch('getRelatedPosts', this.$route.params.post_shortname);
        }
    }
</script>